import * as styles from "./WindowTitle.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useWindowContext } from "./Window.context";
import type { WindowTitleProps } from "./Window.types";

export function WindowTitle({
  className,
  ...props
}: WindowTitleProps): JSX.Element {
  const { titleId } = useWindowContext();

  return (
    <h2
      data-slot="window-title"
      id={titleId}
      className={clsx(styles.title, className)}
      {...props}
    />
  );
}
